const upperFirst = require('mn-utils/upperFirst');
const React = require('react');

const PRIMARY_DATA = [
  {
    title: 'Customer',
    dataHandler: ({customer_email, user_id}) => (
      <>
        <span className="dB">{customer_email}</span>
        <span className="dB break">Customer ID - <b>{user_id}</b></span>
      </>
    ),
  },
  {
    title: 'Retailer',
    dataHandler: ({account = {}}) => !account.name && !account.id
      ? '-'
      : (
        <>
          {account.name && (
            <span className="dB">{account.name} ({account.login})</span>
          )}
          {account.id && (
            <span className="dB break">Retailer ID - <b>{account.id}</b></span>
          )}
        </>
      ),
  },
  // {
  //   title: 'Transaction type',
  //   dataHandler: ({type}) => upperFirst(type || '')
  // },
  {
    title: 'Referral Partner',
    dataKey: 'referral'
  }
];

module.exports = PRIMARY_DATA;
